// bookingTypeUtils.js
// Centralized utility for bookingType-based mappings

const bookingEndpoints = {
  new: {
    query: "/api/bookingsreport/newbookingsquery",
    normal: "/api/bookingsreport/newbookings",
  },
  updated: {
    query: "/api/bookingsreport/updatedbookingsquery",
    normal: "/api/bookingsreport/updatedbookings",
  },
  cancelled: {
    query: "/api/bookingsreport/cancelledbookingsquery",
    normal: "/api/bookingsreport/cancelledbookings",
  },
};

export function getBookingEndpoint(bookingType, query = false) {
  const type = bookingType in bookingEndpoints ? bookingType : "cancelled";
  return query
    ? bookingEndpoints[type].query
    : bookingEndpoints[type].normal;
}

const bookingDateKeyAndLabel = {
  new: { dateKey: "createdDate", dateLabel: "Created" },
  updated: { dateKey: "updatedDate", dateLabel: "Updated" },
  cancelled: { dateKey: "cancelledDate", dateLabel: "Cancelled" },
};

export function getBookingDateKeyAndLabel(bookingType) {
  return (
    bookingDateKeyAndLabel[bookingType] || bookingDateKeyAndLabel["cancelled"]
  );
}
